// Empty default = same origin: the API is served from this site's own host
// at /api/v1, so there is no cross-origin request and no localhost fallback
// that only ever worked on the developer's machine.
// Empty default = same origin. Never default to localhost: that is
// "the visitor's own machine" once built, so the deployed site could
// never reach a backend.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
export const API = `${BACKEND_URL}/api/v1`;
